export default __webpack_public_path__ + "static/media/mapPointer.2fe77844.png";